import React from 'react';
import { AssessmentSubType } from '../../../../enums/assessment-type';
import { QuestionnaireIcon } from '../../../../design/icons/questionnaire.icon';
import { FOPIcon } from '../../../../design/icons/fop.icon';
import { GroupAssessmentIcon } from '../../../../design/icons/group-assessment.icon';
import styles from './assessment-type.module.css';
import classNames from 'classnames';
import { SkeletonOverlay } from '../../../../components/general/loading-state/skeleton-overlay';
import { RatingIcon } from '../../../../design/icons/rating.icon';

export function AssessmentTypeWidget({ assessmentSubType, isLoading }: { assessmentSubType: AssessmentSubType; isLoading: boolean }): React.ReactElement {

  return (
    <SkeletonOverlay isLoading={isLoading} width="100%" height="100%">
      <div className={classNames('card', styles.card)}>
        {assessmentSubType === AssessmentSubType.QuestionnaireAssessment && (
          <React.Fragment>
            <QuestionnaireIcon />
            <div>Questionnaire Assessment</div>
          </React.Fragment>
        )}

        {assessmentSubType === AssessmentSubType.FOPAssessment && (
          <React.Fragment>
            <FOPIcon />
            <div>Field of Practice Assessment</div>
          </React.Fragment>
        )}

        {assessmentSubType === AssessmentSubType.GroupAssessment && (
          <React.Fragment>
            <GroupAssessmentIcon />
            <div>Group Assessment</div>
          </React.Fragment>
        )}

        {assessmentSubType === AssessmentSubType.RatingAssessment && (
          <React.Fragment>
            <RatingIcon />
            <div>Rating Assessment</div>
          </React.Fragment>
        )}
      </div>
    </SkeletonOverlay>
  );
}
